import { render, staticRenderFns } from "./MessageOverview.vue?vue&type=template&id=5f1535e9&scoped=true&"
import script from "./MessageOverview.vue?vue&type=script&lang=js&"
export * from "./MessageOverview.vue?vue&type=script&lang=js&"
import style0 from "./MessageOverview.vue?vue&type=style&index=0&id=5f1535e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1535e9",
  null
  
)

export default component.exports